export { default } from './LabelWithTooltip';
